export const capitalizeSentence = (stringValue: string) => {
  return stringValue[0].toUpperCase() + stringValue.slice(1).toLocaleLowerCase();
};
